import { render } from "./DocumentWrapper.vue?vue&type=template&id=080d35a8&scoped=true&ts=true"
import script from "./DocumentWrapper.vue?vue&type=script&lang=ts"
export * from "./DocumentWrapper.vue?vue&type=script&lang=ts"

import "./DocumentWrapper.vue?vue&type=style&index=0&id=080d35a8&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-080d35a8"]])

export default __exports__